<template>
  <v-container class="pa-0">
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-btn
        v-if="userData.PermissaoAcoes.faturamento.includes('deletelote')"
        :disabled="!selecaoParaEnvio.length && !selecionarTodos? true : false"
        outlined
        color="primary"
        depressed
        height="30px"
        small
        class="px-2 ml-2"
        @click="deleteLoteConfirm(selecaoParaEnvio, {...grupoSelecionado, filter: selectedFilter}, selecionarTodos)"
        >Excluir lote</v-btn
      >
      <v-tooltip v-else center bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            class="px-2 ml-2"
            depressed
            height="30px"
            small
            v-bind="attrs"
            v-on="on"
            >Excluir lote</v-btn
          >
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;"
        >
          Você não possui permissão para executar esta ação.
        </span>
      </v-tooltip>
      <v-btn
        v-if="userData.PermissaoAcoes.faturamento.includes('associarlotesemcronograma')"
        :disabled="!selecaoParaEnvio.length && !selecionarTodos ? true : false"
        color="primary"
        depressed
        height="30px"
        small
        class="px-2 ml-2"
        @click="showOpen(selecaoParaEnvio, grupoSelecionado, selecionarTodos)"
        >Associar a cronograma</v-btn
      >
      <v-tooltip v-else center bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            class="px-2 ml-2"
            depressed
            height="30px"
            small
            v-bind="attrs"
            v-on="on"
            >Associar a cronograma</v-btn
          >
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;"
        >
          Você não possui permissão para executar esta ação.
        </span>
      </v-tooltip>
    </v-row>
    <p class="text-center pt-6 pa-2" v-show="listGrupos.length === 0">
      Não há dados disponíveis
    </p>
    <v-expansion-panels focusable v-model="panel" v class="px-0 pt-3">
      <v-expansion-panel
        v-for="(grupo, ind) in listGrupos"
        :key="ind"
        class="mb-4 pa-0"
        @change="getLotes(grupo, ind)"
      >
        <v-expansion-panel-header class="py-0 px-3">
          <v-row class="ma-0">
            <v-col cols="2" class="pa-0">
              <div v-if="positions == ind" class="check-header">
                <v-icon class="pt-2 pr-1" color="success" size="14px"
                  >fa-check</v-icon
                >
              </div>
              <div class="text-list pres px-0 py-3 ml-7">
                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><b>{{ grupo.prest_nome }}</b></span
                    >
                  </template>
                  <span
                    class="px-3 py-1 ma-0"
                    style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                    >{{ grupo.prest_nome }}</span
                  >
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col class="text-list text-right px-0 py-3">{{
                  grupo.login_prestador
                }}</v-col>
                <v-col class="text-list text-right px-0 py-3"
                  ><b>{{ grupo.oper_nome }}</b></v-col
                >
                <v-col class="text-list text-right px-0 py-3">{{
                  grupo.tipo_guia_descricao
                }}</v-col>
                <v-col class="text-list text-right px-0 py-3"
                  >{{ grupo.total_lotes }} lotes</v-col
                >
                <v-col class="text-list text-right space px-0 py-3"
                  >{{ grupo.qntd_lotes_validados }} validado</v-col
                >
                <v-col class="text-list text-left px-0 py-3"
                  >(R$ {{ grupo.total_vl_lote_validado }})</v-col
                >
                <v-col class="text-list text-right px-0 py-3"
                  >{{ grupo.qntd_lotes_validacao }} em validação</v-col
                >
                <v-col class="text-list text-right space px-0 py-3"
                  >{{ grupo.qntd_lotes_erro }} com erro</v-col
                >
                <v-col class="text-list text-left px-0 py-3"
                  >(R$ {{ grupo.total_vl_lote_erro }})</v-col
                >
              </v-row>
            </v-col>
          </v-row>
          <!-- {{ind}} -->
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            show-select
            v-model="selectedLotes"
            :items="listLotes"
            :items-per-page="pagination.limit"
            hide-default-footer
            dense
            @toggle-select-all="selecionaTodosDoGrupo($event, ind, grupo)"
            @item-selected="selecaoUnica($event, ind, grupo)"
          >
            <!-- @input="valuePosition($event, ind, grupo)" -->
            <template v-slot:item.upload_dt="{ item }">
              {{ item.upload_dt | formatDate }}
            </template>
            <template v-slot:item.estado="{ item }">
              <b
                v-bind:style="{
                  color:
                    item.estado === 'Validado'
                      ? '#45bf96'
                      : item.estado === 'Erro na validação'
                      ? '#da364a'
                      : ''
                }"
                >{{ item.estado }}</b
              >
              <v-btn
                  v-if="item.estado === 'Erro na validação'"
                  @click="infoItem(item, 'erro')" 
                  class="ml-2 py-0 px-0" 
                  :color="item.fl_tratado? '#118aca':'#D0021B'"
                  small 
                  icon>
                <v-icon class="pa-0" small>far fa-eye</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.arq_vl_calculado="{ item }">
              {{ item.arq_vl_calculado | formatPrice }}
            </template>
            <template v-slot:header.estado="{ header }">
              {{ header.text }}
              <v-menu
                offset-y
                max-width="25%"
                :close-on-content-click="closeOnContentClick"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="px-0 py-0" dark v-bind="attrs" v-on="on" icon>
                    <v-icon
                      class="px-1 pt-0"
                      color="primary"
                      size="14px"
                      @click="openInfo = true"
                      >fa-filter</v-icon
                    >
                  </v-btn>
                </template>
                <v-card class="px-3 pt-0 pb-0" outlined flat solo>
                  <v-row v-show="openInfo">
                    <v-col
                      class="text-left px-3 pb-3 pt-2"
                      cols="12"
                      style="color: #035A27"
                    >
                      <v-icon class="px-0 pt-0" color="#035A27"
                        >fa-angle-up</v-icon
                      >
                      ESTADOS
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="1"
                        label="Validados"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem">{{grupo.qntd_lotes_validados}}
                        <!-- {{
                          listLotes.filter((lote) => lote.estado == 'Validado')
                            .length
                        }} -->
                      </div>
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="3"
                        label="Em validação"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem"> {{grupo.qntd_lotes_validacao}}
                        <!-- {{
                          listLotes.filter(
                            (lote) => lote.estado == 'Em validação'
                          ).length
                        }} -->
                      </div>
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="6"
                        label="Erro na validação"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem"> {{grupo.qntd_lotes_erro}}
                        <!-- {{
                          listLotes.filter(
                            (lote) => lote.estado == 'Erro na validação'
                          ).length
                        }} -->
                      </div>
                    </v-col>
                    <v-col class="text-right px-2 pb-3 pt-0" cols="12">
                      <v-btn
                        max-width="100%"
                        height="40px"
                        color="primary"
                        depressed
                        class="px-3"
                        @click="
                          [getListLotes({
                              prestador_id: grupo.prestador_id,
                              operadora_ans_id: grupo.operadora_ans_id,
                              tipo_guia_id: grupo.tipo_guia_id,
                              filter: selectedFilter,
                            }),
                            showSelectedFilter(selectedFilter)]"
                        >Filtrar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
              </v-menu>
            </template>
          </v-data-table>
          <div
            class="text-left pa-0 py-4 col-md-12"
            v-show="showFilter && selectedEstadoFilter.length != 0"
          >
            <b>Filtro:</b>
            <v-chip
              v-for="estado in selectedEstadoFilter"
              :key="estado"
              close
              label
              pill
              @click:close="[
                  removerFiltro(estado),
                  getListLotes({
                    prestador_id: grupo.prestador_id,
                    operadora_ans_id: grupo.operadora_ans_id,
                    tipo_guia_id: grupo.tipo_guia_id,
                    filter: selectedFilter 
                  })]"
              >{{
                estado == 1
                  ? 'Validados'
                  : estado == 3
                  ? 'Em validação'
                  : 'Erro na validação'
              }}</v-chip
            >
          </div>
          <div class="text-center mt-2 py-0 col-md-12">
            <v-pagination
              class="no-box-shadow"
              v-model="page"
              :length="pagination.total_pages"
              @input="getListLotes({
                    prestador_id: grupo.prestador_id,
                    operadora_ans_id: grupo.operadora_ans_id,
                    tipo_guia_id: grupo.tipo_guia_id,
                    filter: selectedFilter,
                  }, page)"
            ></v-pagination>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="text-center mt-2 py-0 col-md-12">
      <v-divider/>
      <v-pagination
        class="no-box-shadow"
        v-model="pageGrupo"
        :length="paginationGrupo.total_pages"
        @input="getListGrupos(pageGrupo)"
      ></v-pagination>
    </div>
    <LotesErrosDlg
      :dialog="showInfo"
      :showClose="() => {showInfo = false; dadosDoLote = {}}"
      :dadosDoLote="dadosDoLote"
      :error="itemError"
      :critica="itemCritica"
      :parameter="false"
      :showValue="showValue"
      :errorType="errorType"
      :userData="userData"
    />
  </v-container>
</template>

<script>
  import moment from 'moment';
  moment.locale('pt-BR');
  import LotesErrosDlg from '@/components/faturamento/lotes_sem_cronograma/LotesErrosDlg'
  export default {
    components:{
      LotesErrosDlg
    },
    data() {
      return {
        pageGrupo: 1,
        page: 1,
        panel: null,
        openedPanel: null,
        valueSelect: null,
        positions: null,
        newPosition: null,
        grupoSelecionado: null,
        selecionarTodos: false,
        selecaoParaEnvio: [],
        novoGrupo: null,
        selectedLotes: [],
        selectedFilter: [],
        selectedEstadoFilter: [],
        showFilter: false,
        openInfo: false,
        dadosDoLote: {},
        itemError: null,
        itemCritica: null,
        errorType: null,
        showValue: null,
        showInfo: null,
        closeOnContentClick: false,
        headers: [
          { text: 'Lote', value: 'arq_nome', sortable: false },
          { text: 'Import.', value: 'upload_dt', sortable: false },
          { text: 'Estado', value: 'estado', class: 'pl-4 pr-0', sortable: false },
          { text: 'Núm. lote', value: 'arq_numero_lote', align: 'center', sortable: false },
          { text: 'Valor (R$)', alue: 'arq_vl_calculado', align: 'right', sortable: false },
          { text: 'Tp. guia', value: 'tipo_guia_descricao', sortable: false },
          { text: 'Qtd. guia', value: 'arq_qtd_guias', align: 'center', sortable: false },
        ]
      };
    },
    methods: {
      infoItem(obj, type) {
      this.showValue = type
      this.dadosDoLote = obj
      this.getError(obj.id).then((resp)=> this.showInfo = resp)
    },
    getLotes(grupo, ind) {
      this.novoGrupo = ind
      this.getListLotes({...grupo, filter: this.selectedFilter });
    },
    async getError(id) {
      let _this = this
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "geterroslote",
          Payload: {
            grupo_economico: this.$store.state.permissions.grupo_economico,
            lote_id: id,
          }
        }],
      }
      let hasErro = await this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader");
            return false;
          }
          
          let json = JSON.parse(response.lote_erros)
          if (response.lote_erros != null) {
            _this.itemError = json.Erros? json.Erros : json.Erro ? json.Erro : null
            _this.itemCritica = json.criticas? json.criticas : null
            _this.errorType = _this.itemError != null? 1 : 2
            return true
          } else {
            _this.itemError = null
            _this.itemCritica = null
            _this.errorType = null
            return false
          }
          
        })
        return hasErro
      },

      modalVideo(){
      let paramModal = {
          codigo: "754272580",
          title: "Como excluir lotes",
      }
      this.$store.commit('tutorial/abreVideo', paramModal);
    },
     
      removerFiltro(estado) {
        var index = this.selectedFilter.indexOf(estado);
        this.selectedFilter.splice(index, 1);
      },
      showSelectedFilter(filter) {
        this.showFilter = true;
        this.selectedEstadoFilter = filter;
        this.openInfo = false;
      },
      position(ind, item) {
        this.valueSelect = ind;
        this.grupoSelecionado = item;
        if (ind != this.positions) {
          this.selectedLotes = [];
        }
      },
      selecionaTodosDoGrupo(selection, ind, grupo) {
        if (selection.value) {
          this.positions = ind;
          this.grupoSelecionado = grupo;
          this.selecionarTodos = true;
          this.selecaoParaEnvio = []
          this.selectedLotes = selection.items;
        } else {
          this.selectedLotes = [];
          this.positions = null;
          this.selecionarTodos = false;
          this.selecaoParaEnvio = []
          this.grupoSelecionado = null;
        }
      },
      selecaoUnica(selection, ind, grupo) {
        //Verifica se existe mudança de grupo
        if (this.positions != ind) {
          this.selectedLotes = []
          this.selecaoParaEnvio = []
          this.positions = ind
          this.grupoSelecionado = grupo
        }
        //Verifica se está marcando ou desmarcando o item
        if (selection.value) {
          this.selectedLotes.push(selection.item);
          if(!this.selecionarTodos) { // Se seleção individual acrescenta na lista
            this.selecaoParaEnvio.push(selection.item);
          } else { // Se seleção total verifica se está incluindo novamente e retira da lista (excessões)
            let index = this.selecaoParaEnvio.findIndex(el => el == selection.item)
            if(index>-1)
            this.selecaoParaEnvio.splice(index, 1);
          }
        } else { //Verifica se está desmarcando o item
          if (this.selectedLotes.length == 0 && !this.selecionarTodos) { // Se seleção individual e é o último a ser desmarcardo zera a seleção de grupo
            this.positions = null;
            this.grupoSelecionado = null;
          } else if(this.selecionarTodos) { // Se seleção total acrescenta na lista (excessões)
              this.selecaoParaEnvio.push(selection.item);
          }
        }
      },
    },
    props: {
      showOpen: Function,
      listGrupos: Array,
      listLotes: Array,
      pagination: Object,
      paginationGrupo: Object,
      getListGrupos: Function,
      getListLotes: Function,
      deleteLoteConfirm: Function,
      userData: Object,
    },
    watch: {
      listGrupos() {
          this.panel = [];
          this.selectedLotes = [];
          this.positions = null;
      },
      listLotes(val){
        if(this.novoGrupo==this.positions && this.selecionarTodos) {
          let _this = this
          val.forEach(item => {
            let index = _this.selecaoParaEnvio.findIndex(el=> el.id == item.id)
            if(index==-1){
              _this.selectedLotes.push(item)
            } 
          })
        }
      }
    },
    filters: {
      formatDate(date) {
        return moment(date).format('L');
      },
      formatNullValue(val) {
        return val ? val : '-';
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
    },
  };
</script>

<style lang="scss">
  .no-box-shadow,
  .no-box-shadow * {
    box-shadow: 0 0 0 0 !important;
  }
  button.v-expansion-panel-header {
    background-color: #eff3f8;
    border-radius: 2px;
    padding: 0;
  }
  .v-expansion-panel::before {
    box-shadow: none;
  }
  .v-expansion-panel-content {
    display: flex;
    margin: 0 -24px;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffffff;
  }
  .text-list {
    font-size: 13px;
  }
  .text-list.space {
    margin-right: 3px;
  }
  .text-list.pres {
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .check-header {
    position: absolute;
    margin-top: 1px;
    margin-left: 5px;
  }
  .check-content {
    position: absolute;
    margin-top: -16px;
  }
  .check-border {
    border: none;
  }
  .porcentagem {
    border-radius: 8px;
    padding: 0 0 0 0;
    text-align: center;
    width: 100%;
    border: 1.5px solid #9e9e9e;
    font-size: 12px;
    color: #9e9e9e;
  }
  .v-expansion-panel-header .row {
    align-items: center;
  }
  .v-chip {
    border-bottom-style: solid;
    left: 0.8rem;
  }
  .v-chip:nth-child(3) {
    margin-left: 0.3rem;
  }
  .v-chip:last-child {
    margin-left: 0.3rem;
  }
  #check-color {
    .v-icon.v-icon {
      align-items: center;
      display: inline-flex;
      font-feature-settings: 'liga';
      font-size: 24px;
      justify-content: center;
      letter-spacing: normal;
      line-height: 1;
      position: relative;
      text-indent: 0;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      color: #118aca;
    }
  }
</style>
